<template>
  <span
    class="inline-flex items-center gap-1 tabular-nums whitespace-nowrap"
    :title="label"
    :aria-label="label"
  >
    <EyeIcon class="w-3.5 h-3.5" aria-hidden="true" />{{ (count ?? 0).toLocaleString() }}
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { EyeIcon } from '@heroicons/vue/24/outline';

const props = defineProps({ count: { type: Number, default: 0 } });
const { t } = useI18n();
const label = computed(() => t('play.lan_party.twitch_watching', { n: (props.count ?? 0).toLocaleString() }));
</script>
